import React, {Component} from 'react';

import AuthActions from '../../actions/AuthActions';
import AuthStore from '../../stores/AuthStore';
import twilioChatClient from "../../twilioChatClient.js";

import {Switch, Route, Redirect, Link} from 'react-router-dom';
import twilioInstance from "../../twilioInstance.js";

import {
  Row,
  Col,
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  NavbarBrand,
  DropdownToggle,
  Button
} from 'reactstrap';

class Header extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {
      dropdownOpen: false,
      messagesCount: 0
    };
  }

  componentWillReceiveProps(nextProps){
    if(nextProps){
      let channelsWithNewMessagesCount = 0;
      nextProps.channelsList.map((channel) =>{
        channel.getUnconsumedMessagesCount().then( count => {
          if(count > 0 && channel.lastMessage){
            if(channel.lastMessage.author != AuthStore.getState().user.username){
              channelsWithNewMessagesCount++;
            }
          }

          this.setState({"messagesCount": channelsWithNewMessagesCount});
        });
      });

      this.forceUpdate();
    }
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  render() {
    if(!this.props.channelsList) return (null);

    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>&#9776;</NavbarToggler>
        <NavbarBrand href="#"></NavbarBrand>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarMinimize}>&#9776;</NavbarToggler>

        <Nav className="ml-auto" navbar>
          <NavItem>
            <Row className="margin-right">
              <Col xs="8" md="8" className="phone-box-txt text-right">

                <div className={twilioInstance.isConnected && twilioInstance.incoming? '' : 'hidden'}>
                  <small>Conversando com { this.props.callInfo ? this.props.callInfo.clientName : " - "} {'\u00A0'}</small>
                  <br />
                  <small><i>{twilioInstance.connection ? twilioInstance.connection.parameters.From : " - " }</i></small>
                  <br />
                  {this.props.callInfo ?
                  <small><i><Link to={"/examViewer/"+(this.props.callInfo ? this.props.callInfo.examId : "000")}>Ver exame {this.props.callInfo ? this.props.callInfo.examPublicId : ""} {'\u00A0'}</Link></i></small>
                  : "" }
                </div>
              </Col>
              <Col xs="4" md="4" className="phone-box-btn text-left">
                <div className={twilioInstance.isConnected && twilioInstance.incoming ? '' : 'hidden'}>
                  <Button color="danger" onClick={this.props.disconnect}><i className="fa fa-phone fa-blink"></i>{'\u00A0'} Encerrar </Button>
                </div>
              </Col>
            </Row>
          </NavItem>
          <NavItem>
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
              <DropdownToggle className="nav-link dropdown-toggle">
                <img src={'img/avatars/user.jpg'} className="img-avatar" alt="User"/>
                <span className="d-md-down-none">
                  {AuthStore.getState().user.entity_name}
                </span>
              </DropdownToggle>
              <DropdownMenu right className={this.state.dropdownOpen ? 'show' : ''}>
                <DropdownItem header tag="div" className="text-center"><strong>Perfil</strong></DropdownItem>
                <DropdownItem href="#/myaccount"><i className="fa fa-user"></i> Minha Conta</DropdownItem>
                <DropdownItem href="#/logout"><i className="fa fa-lock"></i> Logout</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavItem>
        </Nav>

        <NavbarToggler className="d-md-down-none" type="button" onClick={this.asideToggle}>
          <i className="icon-bell"></i>
          {
            this.state.messagesCount > 0 ? <Badge pill color="danger">{this.state.messagesCount}</Badge> : ""
          }
        </NavbarToggler>

        {'\u00A0'}{'\u00A0'}
      </header>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js